import $ from 'jquery';
import RevealWhenVisible from '../../components/reveal-when-visible';
import ScrollTo from '../../components/scroll-to';
import ProductTradeIn from './components/product-trade-in';
import ProductVariantColorSelect from '../../components/product-variant-color-select';
import IframeFullHeight from '../../components/iframe-full-height';
import VideoModalButton from '../../components/video-modal-button';
$(() => {
    ScrollTo.init();
    RevealWhenVisible.init();
    ProductTradeIn.init();
    ProductVariantColorSelect.init();
    IframeFullHeight.init();
    VideoModalButton.init();
});
